import type { SvgProps } from "components/icons/types";

// fi-rs-undo — curved back-arrow; natural ~12x12 aspect.
export const FiUndo = (props: SvgProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12.0007 11.707"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0007 11.707H11.0007C10.9996 10.7791 10.6305 9.88944 9.97439 9.23329C9.31824 8.57715 8.42861 8.20806 7.50068 8.207H5.08568V11.414L0.43918 6.7675C0.157973 6.48621 0 6.10475 0 5.707C0 5.30925 0.157973 4.92779 0.43918 4.6465L5.08568 0V3.207H7.50068C8.69375 3.20832 9.83757 3.68285 10.6812 4.52648C11.5248 5.37011 11.9994 6.51393 12.0007 7.707V11.707ZM4.08568 2.414L1.14618 5.3535C1.05244 5.44726 0.999787 5.57442 0.999787 5.707C0.999787 5.83958 1.05244 5.96674 1.14618 6.0605L4.08568 9V7.207H7.50068C8.1721 7.20696 8.835 7.35735 9.44068 7.64712C10.0464 7.93689 10.5794 8.35868 11.0007 8.8815V7.707C10.9996 6.77907 10.6305 5.88944 9.97439 5.2333C9.31824 4.57715 8.42861 4.20806 7.50068 4.207H4.08568V2.414Z"
      fill="currentColor"
    />
  </svg>
);
